import React from 'react';
import { motion } from 'framer-motion';
import { PartnerCard } from './PartnerCard';
import { partners } from './partnersData';

export default function Partners() {
  return (
    <section id="partners" className="flex-grow bg-white pt-0 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-extrabold text-gray-800">Our Partners</h2>
        <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-700">
          Collaborating with leading institutions for climate finance education in Africa.
        </p>
      </div>
      <div className="mt-12 grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3">
        {partners.map((partner) => (
          <PartnerCard key={partner.name} partner={partner} />
        ))}
      </div>
    </section>
  );
}
